<template>
  <div class="organization-settings bg-white border border-gray-50 rounded-8">
    <div>
      <SupplierTable @update="fetchPublicSuppliers()" />
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

import SparkButton from '../../../../components/SparkComponents/SparkButton.vue';

import CreateSupplierModal from './components/CreateSupplierModal.vue';
import SupplierTable from './components/SupplierTable.vue';

export default {
  name: 'SupplierSettings',

  components: { SupplierTable, CreateSupplierModal, SparkButton },

  data() {
    return {
      showModal: false,
      isMounted: false,
    };
  },

  computed: {
    ...mapState('supplier', ['publicSuppliers', 'customersSuppliers']),
  },

  async mounted() {
    await this.fetchSelectedSuppliers(); // Get all supplier
    await this.fetchPublicSuppliers(); // Get the selected suppliers from backend
    await this.fetchCustomersSuppliers(); // Get the selected suppliers from backend
    this.isMounted = true;
  },

  methods: {
    ...mapActions('supplier', ['fetchSelectedSuppliers', 'fetchPublicSuppliers', 'fetchCustomersSuppliers']),

    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
